<script setup>
import { computed } from 'vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';
import { getSportLiveTvEventMeta, getSportLiveTvEventTitle } from '@/sport-live-tv/helpers';

const props = defineProps({
  event: { type: Object, required: true },
  scoresVisible: { type: Boolean, default: false },
});

const { t, locale } = useSportLiveTvTranslation();

const title = computed(() => getSportLiveTvEventTitle(props.event));
const meta = computed(() => getSportLiveTvEventMeta(props.event, props.scoresVisible, { today: t('today'), tomorrow: t('tomorrow') }, locale.value));
</script>

<template>
  <div class="sport-live-tv-event-card-info">
    <p class="sport-live-tv-event-card-info__title">{{ title }}</p>
    <p class="sport-live-tv-event-card-info__meta">{{ meta }}</p>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-event-card-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 12px 12px;
  text-align: center;

  &__title,
  &__meta {
    max-width: 100%;
    overflow: hidden;
    color: $white10;
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;

    @include mobile-sm-max {
      font-size: 11px;
    }
  }

  &__meta {
    padding-top: 5px;
  }
}
</style>
